<template>
  <span>{{formatedDate}}</span>
</template>
<script>
var dayjs = require('dayjs');
var customParseFormat = require('dayjs/plugin/customParseFormat');
var localizedFormat = require('dayjs/plugin/localizedFormat')

dayjs.extend(localizedFormat)
dayjs.extend(customParseFormat);

/*
<format-date date="1566360000"></format-date>
<format-date format="DD/MM/YYYY" date="23/07/2019"></format-date>
*/
export default {
  props: {
    date: {
      type: String
    },
    format: {
      type: String,
      default: ''
    },
    output: {
      type: String,
      default: 'DD MMMM YYYY'
    }
  },
  computed: {
    formatedDate: function() {
      return dayjs(this.unixTimeStamp).format(this.output);
    },
    unixTimeStamp: function() {
      if (this.format === ''){
        return parseInt(this.date) * 1000;
      } else {
        return dayjs(this.date, this.format).unix() * 1000
      }
    }
  }
};
</script>
